import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Report, ReportRequest } from '../models/report.model';
import { ReportApi } from '../api/report.api';

@Injectable({ providedIn: 'root' })
export class ReportService {
  private readonly _api = inject(ReportApi);

  public list(userId: number): Observable<Report[]> {
    return this._api.list(userId);
  }

  public request(reportRequest: ReportRequest): Observable<string> {
    return this._api.request(reportRequest);
  }

  public downloadUrl(filename: string, type: string): Observable<string> {
    return this._api.downloadUrl(filename, type);
  }

  public userActivityReportFilename(): Observable<string> {
    return this._api.userActivityReport();
  }
}
